import { connect, MapStateToProps } from 'react-redux';
import { Props } from './PageContainer';
import { AppState } from '../../../../types/store';
import { getShouldShowFooter } from '../../../../selectors/app';
import { getBiDetails } from '../../../../selectors/biLogger';

export type StateProps = Pick<Props, 'withFooter' | 'biData'>;
export type OwnProps = Props;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { withFooter }
) => ({
  // favor prop if passed then selector
  withFooter: withFooter ?? getShouldShowFooter(state),
  biData: getBiDetails(state),
});

export default connect(mapStateToProps);
